<template>
  <div class="lead-opportunity">
    <a
      href="javascript:;"
      @click="toggle"
    ><i :class="['fa', activeClass, customClass]" /><span v-show="show"><span v-if="active">{{ __('Marcado como oportunidade') }}</span><span v-else>{{ __('Marcar como oportunidade') }}</span></span></a>
  </div>
</template>

<script>
export default {
  props: {
    hash: {
      required: true,
    },
    opportunity: {
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    customClass: {
      default: null,
    },
  },

  data () {
    return {
      active: this.opportunity,
    };
  },

  computed: {
    activeClass () {
      return this.active ? 'fa-star text-danger' : 'fa-star-o';
    },
  },

  methods: {
    toggle () {
      this.active = ! this.active;

      this.$http.put(`/lead/${this.hash}`, { opportunity: this.active });
      try {
        this.$http.put(`/lead/${this.hash}`, { opportunity: this.active });
        Bus.$emit('opportunity-change', { hash: this.hash, opportunity: this.active });
      } catch (error) {
        this.active = previousValue;
        console.error('Erro ao atualizar oportunidade:', error);
      }
    },
  },
};
</script>
